<template>
    <div>

        <div class="my-6 flex items-center">
            <span class="inline-block mr-6">Select a date: </span>
            <select class="form-input my-0" name="month" id="" v-model="date.month">
                <option v-for="i in 12" :value="i - 1">{{ showMonthName(i - 1) }}</option>
            </select>
            <span class="inline-block mx-2">/</span>
            <select class="form-input my-0" name="year" id="" v-model="date.year">
                <option v-for="i in yearSelect" :value="i">{{i}}</option>
            </select>

            <button @click="selectDate(-1)" class="btn btn-info ml-6" style="min-width: 2.8rem;">-</button>
            <button @click="selectDate(1)" class="btn btn-info ml-6" style="min-width: 2.8rem;">+</button>

            <button @click="getData" class="btn btn-info ml-6">
                Select
            </button>

            <router-link target="_blank" :to="{name: 'preview-all', params: {month: date.month, year: date.year}}" class="btn btn-primary ml-24 flex items-center">
                <span class="mr-4">
                    <Zondicon icon="printer" class="w-4 fill-current" />
                </span>
                <span>Preview all</span>
            </router-link>

            <router-link target="_blank" :to="{name: 'report', params: {month: date.month, year: date.year}}" class="btn btn-primary ml-8 flex items-center">
                <span class="mr-4">
                    <Zondicon icon="document" class="w-4 fill-current" />
                </span>
                <span>Report</span>
            </router-link>
        </div>


        <div v-if="init && !loading">
            
            <div style="max-height:72vh;" class="border border-gray-300 mb-12 overflow-x-scroll" v-if="users.length > 0">
        
                <table class="table w-full relative">
                    <thead>
                        <tr>
                            <th class="sticky z-20" style="top: -1px;">
                                <div class="flex items-center">
                                    <div>User</div>
                                    <div class="ml-2 text-gray-600 cursor-pointer" @click="sort.name = !sort.name">
                                        <Zondicon v-if="sort.name" icon="arrow-thick-down" class="w-4 fill-current" />
                                        <Zondicon v-else icon="arrow-thick-up" class="w-4 fill-current" />
                                    </div>
                                </div>
                            </th>
                            <th class="sticky z-20" style="top: -1px;">Role</th>
                            <th class="sticky z-20" style="top: -1px;">Team leader</th>
                            <th class="sticky z-20" style="top: -1px; width: 50px">
                                <span class="tooltip">
                                    <span>Rvd+</span>
                                    <span class="tooltip-text capitalize" style="left: 0px; top: 80px;">Remaining vacation days (spent + planned)</span>
                                </span>
                            </th>
                            <th class="sticky z-20" style="top: -1px; width: 50px">
                                <span class="tooltip">
                                    <span>Vac</span>
                                    <span class="tooltip-text capitalize" style="left: 0px; top: 80px;">Vacation (days)</span>
                                </span>
                            </th>
                            <th class="sticky z-20" style="top: -1px; width: 50px">
                                <span class="tooltip">
                                    <span>Ovt</span>
                                    <span class="tooltip-text capitalize" style="left: 0px; top: 80px;">Overtime (hours)</span>
                                </span>
                            </th>
                            <th class="sticky z-20" style="top: -1px;">Preview</th>
                            <th class="sticky z-20" style="top: -1px;">
                                <CellType>
                                    <template v-slot:type>Checked</template>
                                    <template v-slot:by>by accounter</template>
                                </CellType>
                            </th>
                            <th class="sticky z-20" style="top: -1px;">
                                <CellType>
                                    <template v-slot:type>Published</template>
                                    <template v-slot:by>by employee</template>
                                </CellType>
                            </th>
                            <th class="sticky z-20" style="top: -1px;">
                                <CellType>
                                    <template v-slot:type>Confirmed</template>
                                    <template v-slot:by>by team leader</template>
                                </CellType>
                            </th>
                            <th class="sticky z-20" style="top: -1px;">
                                <CellType>
                                    <template v-slot:type>Approved</template>
                                    <template v-slot:by>by manager</template>
                                </CellType>
                            </th>
                            <th v-if="canAccess('canEditAccounterDashboard')" class="sticky z-20" style="top: -1px;">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in filteredUsers" :key="user.uid" :class="getRoleClass(user.role)">

                            <td>
                                <div class="flex items-center">
                                    <span>
                                        <Zondicon icon="user" class="w-4 mr-4 fill-current" />
                                    </span>
                                    <span>{{ user.name }}</span>
                                    <div class="tooltip" v-if="user.isPartTime">
                                        <div class="w-2 h-2 bg-blue-500 rounded-full ml-2"></div>
                                        <span class="tooltip-text">Part time</span>
                                    </div>
                                    <div class="tooltip" v-if="user.isExternal">
                                        <div class="w-2 h-2 bg-yellow-600 rounded-full ml-2"></div>
                                        <span class="tooltip-text">External employee</span>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div class="text-xs italic">
                                	{{ getRoleName(user.role) }}
                                </div>
                            </td>

                            <td>
                                <div v-if="isSubordinate(user.uid)" class="text-xs italic">
                                    {{ isSubordinate(user.uid).name }}
                                </div>
                            </td>

                            <td>
                                <div class="text-xs text-center">
                                	{{ getRemainingVacationDaysWithPlanned(user.uid) }}
                                </div>
                            </td>

                            <td>
                                <div class="text-xs text-center">
                                	{{ getVacMonthTotal(user.uid) }}
                                </div>
                            </td>

                            <td>
                                <div class="text-xs text-center">
                                	{{ getOvtMonthTotal(user.uid) }}
                                </div>
                            </td>

                            <td>
                                <div v-if="getMarktime(user.uid)" class="text-center">
                                    <router-link v-if="getMarktime(user.uid).published" :to="{name: 'preview', params: {id: getMarktime(user.uid).id}}" target="_blank" class="text-sm mr-2 btn btn-small btn-info">
    									Preview
    								</router-link>
                                </div>
                            </td>

                            <td>
                                <div v-if="getMarktime(user.uid)">
                                    <div v-if="getMarktime(user.uid).published && (!isSubordinate(user.uid) || getMarktime(user.uid).confirmed)">
                                        <div v-if="getMarktime(user.uid).checked">
                                            <div class="flex items-center leading-tight">
                                                <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                                <div>checked</div>
                                            </div>
                                            <div class="leading-tight">
                                                <span class="text-gray-500 italic text-xs">{{ getDate(getMarktime(user.uid).checkedDate) }}</span>
                                            </div>
                                        </div>
                                        <div v-else class="text-center">
                                            <button v-if="canAccess('canEditAccounterDashboard')" @click="showCheckModal(getMarktime(user.uid).id)" class="btn btn-small btn-secondary mr-2">
                                                Check
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div v-if="getMarktime(user.uid)">
                                    <div v-if="getMarktime(user.uid).published">
                                        <div class="flex items-center leading-tight">
                                            <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                            <div>published</div>
                                        </div>
                                        <div class="leading-tight">
                                            <span class="text-gray-500 italic text-xs">{{ getDate(getMarktime(user.uid).publishedDate) }}</span>
                                        </div>
                                    </div>
                                    <div v-else class="flex items-center">
                                        <div class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                                        <div>not yet</div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div v-if="isSubordinate(user.uid)">
                                    <div v-if="getMarktime(user.uid)">
                                        <div v-if="getMarktime(user.uid).confirmed">
                                            <div class="flex items-center leading-tight">
                                                <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                                <div>confirmed</div>
                                            </div>
                                            <div class="leading-tight">
                                                <span class="text-gray-500 italic text-xs">{{ getDate(getMarktime(user.uid).confirmedDate) }}</span>
                                            </div>
                                        </div>
                                        <div v-else class="flex items-center">
                                            <div class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                                            <div>not yet</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>N/A</div>
                            </td>

                            <td>

                                <div v-if="getMarktime(user.uid)">
                                    <div v-if="getMarktime(user.uid).approved">
                                        <div class="flex items-center leading-tight">
                                            <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                            <div>approved</div>
                                        </div>
                                        <div class="leading-tight">
                                            <span class="text-gray-500 italic text-xs">{{ getDate(getMarktime(user.uid).approvedDate) }}</span>
                                        </div>
                                    </div>
                                    <div v-else class="flex items-center">
                                        <div class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                                        <div>not yet</div>
                                    </div>
                                </div>

                            </td>

                            <td v-if="canAccess('canEditAccounterDashboard')">
                                <div v-if="getMarktime(user.uid)" class="flex items-center">
									<router-link v-if="!getMarktime(user.uid).checked && getMarktime(user.uid).published" title="Edit" class="text-gray-600 cursor-pointer mr-4 tooltip" :to="{name: 'marktime-edit', params: {id: getMarktime(user.uid).id}}" tag="span">
										<Zondicon icon="edit-pencil" class="w-4 fill-current" />
                                        <span class="tooltip-text -ml-2">Edit</span>
									</router-link>
                                    <div v-if="getMarktime(user.uid).published && !getMarktime(user.uid).checked" class="text-gray-600 cursor-pointer mr-4 tooltip" @click="openUnpublishModal(getMarktime(user.uid).id)">
										<Zondicon icon="arrow-outline-up" class="w-4 fill-current" />
                                        <span class="tooltip-text">Unpublish</span>
									</div>
                                    <div v-if="!getMarktime(user.uid).checked && getMarktime(user.uid).confirmed" class="text-gray-600 cursor-pointer mr-4 tooltip" @click="openUnconfirmModal(getMarktime(user.uid).id)">
										<Zondicon icon="browser-window-open" class="w-4 fill-current" />
                                        <span class="tooltip-text">Unconfirm</span>
									</div>
                                    <div v-if="getMarktime(user.uid).checked" class="text-gray-600 cursor-pointer mr-4 tooltip" @click="openUncheckModal(getMarktime(user.uid).id)">
										<Zondicon icon="key" class="w-4 fill-current" />
                                        <span class="tooltip-text">Uncheck</span>
									</div>
								</div>
                            </td>


                        </tr>
                    </tbody>
                </table>

            </div>

            <div v-else>No marktimes in selected date.</div>

        </div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

        <SimpleModal v-if="showModal" @action="check" @close="showModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Check this marktime</template>
            <template v-slot:body>Are you sure you want to check this marktime?</template>
            <template v-slot:button>Check</template>
        </SimpleModal>

        <SimpleModal v-if="showUnpublishModal" @action="unpublish" @close="showUnpublishModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Unpublish this marktime</template>
            <template v-slot:body>Are you sure you want to unpublish this marktime?</template>
            <template v-slot:button>Unpublish</template>
        </SimpleModal>

        <SimpleModal v-if="showUncheckModal" @action="uncheck" @close="showUncheckModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Uncheck this marktime</template>
            <template v-slot:body>Are you sure you want to uncheck this marktime?</template>
            <template v-slot:button>Uncheck</template>
        </SimpleModal>

        <SimpleModal v-if="unconfirmModal" @action="unconfirm" @close="unconfirmModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Unconfirm this marktime</template>
            <template v-slot:body>Are you sure you want to unconfirm this marktime?</template>
            <template v-slot:button>Unconfirm</template>
        </SimpleModal>

    </div>
</template>

<script>
import moment from 'moment';
import { mapState } from "vuex";
import { db } from "@/firebase";
import Zondicon from 'vue-zondicons'
import helper from '../../helpers'
import mixinDashboard from '../../mixins/dashboard'

import SimpleModal from '@/components/SimpleModal.vue'
import CellType from '@/components/CellType.vue'

export default {

    mixins: [
        mixinDashboard
    ],

    data() {
        return {
            loading: false,
            showModal: false,
            showUnpublishModal: false,
            showUncheckModal: false,
            unconfirmModal: false,
            key: null,
            sort: {
				name: true
			}
        }
    },

    computed: {
        
        init() {
            if (this.users && this.currentUser) return true
            return false
        },
        
        ...mapState({
			currentUser: state => state.user.info,
			roles: state => state.roles,
			users: state => state.users,
		}),

        filteredUsers() {
            var users = []

            if (this.marktimes && this.users) {
                users = this.users
            }

            users = users.filter(user => {
				if (user.role !== 'superadmin' && user.name !== 'Calendar (external)' && !user.archived) return 1
			})

            users = users.sort((a, b) => {
				if (this.sort.name) {
					return a.name.localeCompare(b.name)
				}
				if (!this.sort.name) {
					return b.name.localeCompare(a.name)
				}
            })

            return users;
        },

        yearSelect() {
            var yearArray = []
            for (var i = this.date.year - 5; i <= this.date.year + 3; i++) {
                yearArray.push(i)
            }
            return yearArray;
        },
    },

    components: {
        SimpleModal,
        Zondicon,
        CellType
    },

    methods: {

        canAccess(type) {
            return helper.canAccess(type, this.currentUser)
        },

        getVacMonthTotal(uid) {
            return helper.getVacMonthTotal(this.getMarktime(uid))
        },

        getOvtMonthTotal(uid) {
            return helper.getOvtMonthTotal(this.getMarktime(uid))
        },

        getMarktime(uid) {
            if (this.marktimes) {
                return this.marktimes.find(marktime => marktime.user === uid)
            }
            return false
        },

        isSubordinate(uid) {
            return this.users.find(user => {
                if (user.subordinates.indexOf(uid) > -1 && user.role !== 'superadmin') return user
            })
        },

        showMonthName(i) {
            return moment({
                month: i
            }).format('MMMM')
        },

        getRoleName(id) {
			if (this.roles) {
				return this.roles.find(role => role.id == id).name
			}
			return id
        },
        
        getRoleClass(roleId) {
            var className = ''
            switch (roleId) {
                case 'nZorCHA3D3opPKdu4Arx':
                    className = 'manager'
                    break;
                case 'rPHdxrt3Uatga4u9jx5T':
                    className = 'team-leader'
                    break;
                case 'u3WQdP6NiAhPrdQsBM4N':
                    className = 'accounter'
                    break;
            }
            
            return className;

        },

        getUserName(uid) {
			return this.users.find(user => user.uid === uid).name
        },

        showCheckModal(key) {
            this.key = key
            this.showModal = true
        },

        openUnconfirmModal(key) {
            this.key = key
            this.unconfirmModal = true
        },

        unconfirm() {

            db
            .collection('marktimes')
            .doc(this.key)
            .update({
                confirmed: false,
                confirmedDate: null
            })
            .then(() => {
                this.unconfirmModal = false
                this.$toasted.show(`Unconfirmed successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
                this.unconfirmModal = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
        },

        getDate(time) {
            if (time) {
                return moment(time.seconds * 1000).format('DD. MM. YYYY HH:mm')
            }
            return ''
        },

        check() {

            db
            .collection('marktimes')
            .doc(this.key)
            .update({
                checked: true,
                checkedDate: new Date()
            })
            .then(() => {
                this.showModal = false
                this.$toasted.show(`Checked successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
                this.showModal = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
        },

        openUnpublishModal(id) {
            this.key = id
            this.showUnpublishModal = true
        },

        unpublish() {
            db
            .collection('marktimes')
            .doc(this.key)
            .update({
                published: false,
                publishedDate: null
            })
            .then(() => {
                this.showUnpublishModal = false
                this.$toasted.show(`Unpublished successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
                this.showUnpublishModal = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
        },


        openUncheckModal(id) {
            this.key = id
            this.showUncheckModal = true
        },

        uncheck() {
            db
            .collection('marktimes')
            .doc(this.key)
            .update({
                checked: false,
                checkedDate: null
            })
            .then(() => {
                this.showUncheckModal = false
                this.$toasted.show(`Unpublished successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
                this.showUncheckModal = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
        },


        selectDate(add) {

            var time = moment({
                year: this.date.year,
                month: this.date.month
            })
            time.add(add, 'months')
            this.date.month = time.month()
            this.date.year = time.year()

            this.getMarktimes()
            this.getVacations()
        },

        getMarktimes() {

            this.loading = true
        
            db
            .collection('marktimes')
            .where('year', '==', this.date.year)
            .onSnapshot(query => {
                var marktimes = []
                query.forEach(function (doc) {
                    var marktime = doc.data()
                    marktime.id = doc.id
                    marktimes.push(marktime)
                });
                this.allMarktimes = marktimes
                this.loading = false
            })

        },

        getVacations() {

            db
            .collection('vacations')
            .where('from', '>=', new Date(this.date.year, 0, 1, 0, 0))
            .where('from', '<=', new Date(this.date.year, 11, 31, 23, 59))
            .onSnapshot(query => {
                var vacations = []
                query.forEach(function (doc) {
                    var vacation = doc.data()
                    vacation.id = doc.id
                    vacations.push(vacation)
                });
                this.allVacations = vacations
            })

        },

        getData() {
            this.getMarktimes()
            this.getVacations()
        }

    },

    created() {

        var interval = setInterval(() => {
            if (this.currentUser) {
                this.getMarktimes()
                if (!this.users) this.$store.dispatch('getUsers')
                if (!this.roles) this.$store.dispatch('getRoles')
                clearInterval(interval)
            }
        }, 100)

        this.getVacations()

        this.$store.commit('SET_TITLE', 'Dashboard (Accounter)')
    }

}
</script>